import { Component } from 'react';
import { DRAGDROP_TYPE } from 'crm_components/dialog/propertyListEditor/PropertyListEditorConstants';
import { ENTER } from '../../utils/keyCodes';
import PropTypes from 'prop-types';
import RestrictedPropertyIcon from './RestrictedPropertyIcon';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import DnDListWrapper from 'customer-data-ui-utilities/dnd/DnDListWrapper';
import { Button } from 'foundations-components/transitional/components/Button';
import withRestrictedProperties from './withRestrictedProperties';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { MoveableObject } from 'foundations-components/transitional/components/MoveableObject';
import { Flex } from 'foundations-components/components/Flex';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MoveToTopWrapper = styled.div.withConfig({
  displayName: "DnDPreviewItem__MoveToTopWrapper",
  componentId: "ktkhqs-0"
})(["position:absolute;padding-left:10px;right:30px;top:9px;background:", ";"], ({
  theme
}) => `linear-gradient(to right, transparent 0px, ${theme.color['fill-primary-disabled']} 10px)`);
export class DnDPreviewItem extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      isHovering: false
    };
    this.handleMouseDown = e => {
      e.stopPropagation();
    };
    this.handleMouseEnter = () => {
      this.setState({
        isHovering: true
      });
    };
    this.handleMouseLeave = () => {
      this.setState({
        isHovering: false
      });
    };
    this.handleMoveToTop = () => {
      const {
        index,
        onMove
      } = this.props;
      onMove(index, 0);
    };
    this.handleEnter = ({
      keyCode
    }) => {
      if (keyCode !== ENTER) {
        return;
      }
      if (typeof this.props.onRemove === 'function') this.props.onRemove();
    };
    this.renderContent = () => {
      const {
        isRestricted,
        option,
        onRemove,
        onMove
      } = this.props;
      const {
        isHovering
      } = this.state;
      const text = option.text || option.value;
      return /*#__PURE__*/_jsxs(MoveableObject, {
        draggable: onMove != null && !option.disabled,
        onClose: onRemove,
        closeable: !(option.readOnly || option.disabled)
        // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
        ,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        "data-test-id": "highlight-moveable-object",
        children: [/*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "100",
          children: [isRestricted && /*#__PURE__*/_jsx(RestrictedPropertyIcon, {}), /*#__PURE__*/_jsx(TruncateString, {
            children: text
          })]
        }), isHovering && !option.disabled &&
        /*#__PURE__*/
        // @bend-expect trellis-tokenized
        _jsx(MoveToTopWrapper, {
          children: /*#__PURE__*/_jsx(Button, {
            use: "link",
            onClick: this.handleMoveToTop,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "crm_components.PropertyListEditor.moveToTop"
            })
          })
        })]
      });
    };
  }
  render() {
    const {
      connectDragSource,
      connectDropTarget,
      onMove,
      option
    } = this.props;
    if (onMove != null && !option.disabled) {
      return connectDragSource(connectDropTarget( /*#__PURE__*/_jsx("div", {
        children: this.renderContent()
      })));
    }
    return this.renderContent();
  }
}
DnDPreviewItem.displayName = 'DnDPreviewItem';
DnDPreviewItem.propTypes = {
  connectDragSource: PropTypes.func.isRequired,
  connectDropTarget: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  isRestricted: PropTypes.bool,
  onMove: PropTypes.func,
  onRemove: PropTypes.func,
  option: PropTypes.object.isRequired
};
DnDPreviewItem.defaultProps = {
  isRestricted: false
};
export default DnDListWrapper(DRAGDROP_TYPE, props => ({
  option: props.option
}), {
  isDragging(item, monitor) {
    return item.option === monitor.getItem().data.option;
  }
})(withRestrictedProperties(DnDPreviewItem));